export default "__VITE_ASSET__c0a6bf82__"